var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchukoEu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b,.d{fill:#c8d1ec;}.c,.f{fill:#fff;}.e,.f{stroke:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 74,
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-148 -702)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-6329-3147.424h0a20.789,20.789,0,0,1-11.849-5.94,20.868,20.868,0,0,1-6.152-14.85,20.979,20.979,0,0,1,5.184-13.813A20.987,20.987,0,0,1-6329-3189v2.491a3,3,0,0,0,3,3,3,3,0,0,0,3-3V-3189a20.98,20.98,0,0,1,12.816,6.972,20.972,20.972,0,0,1,5.184,13.813,20.868,20.868,0,0,1-6.15,14.85,20.775,20.775,0,0,1-11.849,5.939v-2.084a3,3,0,0,0-3-3,3,3,0,0,0-3,3v2.084Z",
    transform: "translate(6511 3907.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2,0A2,2,0,1,1,0,2,2,2,0,0,1,2,0Z",
    transform: "translate(183 737)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(168.186 734.309)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(192.186 734.309)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchukoEu);
export default __webpack_public_path__ + "static/media/schuko_eu.e03d66cd6a09c8068c4c34e240a26419.svg";
export { ForwardRef as ReactComponent };